import { Card } from '@mui/material';
import React from 'react';
import style from './frame.card.module.scss';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const FrameCard = ({ cardProps, jsx, el }) => {
  const childWithProps = React.cloneElement(jsx, el);

  return (
    <React.Fragment>
      <Card
        sx={{
          ...(cardProps || {}),
        }}
        className={style.card}
      >
        {childWithProps}
      </Card>
    </React.Fragment>
  );
};

export default FrameCard;
